import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"
// import Vconsole from 'vconsole'

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ElementUIX from 'vue-element-ui-x';

import './components/vant' // 引入 Vant 配置

import '@/styles/channel.scss' // 各渠道自定义样式

import codeMix from "./mixins/codeMix.js";
Vue.mixin(codeMix);
//
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)
// new Vconsole()

import VueAwesomeSwiper from 'vue-awesome-swiper';
import'swiper/css/swiper.css'; // 引入 Swiper 样式

Vue.use(VueAwesomeSwiper);

import tool from "@/utils/encrypt";

Vue.prototype.$tool = tool;

Vue.config.productionTip = false;

// 引入 Element UI
Vue.use(ElementUI);
import Viewer from 'v-viewer'
import "viewerjs/dist/viewer.css";
Vue.use(Viewer)
Vue.mixin({
  methods: {
    getContainerFn() {
      return document.getElementsByClassName('admin-layout')[0]
    },
  }
})
// 引入 Element-UI-X
Vue.use(ElementUIX);

Vue.use(Antd);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
